var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAadLogoWms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 200",
    style: {
      enableBackground: "new 0 0 300 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#999999;}\r\n\t.st1{fill:#99CC33;}\r\n\t.st2{fill:#6699CC;}\r\n\t.st3{fill:#FF9900;}\r\n\t.st4{fill:#AEDB7E;}\r\n\t.st5{fill:#8BBEE9;}\r\n\t.st6{fill:#FFCC00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.6,
    y: 157.8,
    className: "st0",
    width: 274.4,
    height: 2.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,184.4c-1.4,0-2.7-0.5-3.7-1.5c-1.4-1.4-1.4-2.7-1.4-6c0-3.4,0-4.7,1.4-6c1-1,2.3-1.5,3.7-1.5 c2.6,0,4.6,1.6,5,4.3h-1.1c-0.4-2-1.9-3.3-3.9-3.3c-1.1,0-2.1,0.4-2.8,1.1c-1.1,1.1-1.1,2.2-1.1,5.4c0,3.2,0.1,4.3,1.1,5.4 c0.8,0.7,1.8,1.1,2.8,1.1c2,0,3.5-1.3,3.9-3.3h1.1C22,182.7,20,184.4,17.4,184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,182.9c-1,1-2.3,1.5-3.7,1.5c-1.4,0-2.7-0.5-3.7-1.5c-1.4-1.4-1.4-2.7-1.4-6c0-3.4,0-4.7,1.4-6 c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5c1.4,1.4,1.4,2.7,1.4,6C39,180.2,39,181.5,37.7,182.9z M36.8,171.4 c-0.8-0.8-1.8-1.1-2.8-1.1c-1.1,0-2.1,0.4-2.8,1.1c-1.1,1.1-1.1,2.2-1.1,5.4c0,3.2,0.1,4.3,1.1,5.4c0.8,0.7,1.8,1.1,2.8,1.1 c1.1,0,2.1-0.4,2.8-1.1c1.1-1.1,1.1-2.2,1.1-5.4C37.9,173.6,37.8,172.5,36.8,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,184.3l-3.5-6.8h-4.1v6.8h-1.1v-14.8h5.6c2.4,0,4.3,1.4,4.3,4c0,2.2-1.3,3.6-3.4,4l3.6,6.9H54.9z  M51.7,170.4h-4.4v6h4.4c1.9,0,3.3-1,3.3-3C54.9,171.4,53.6,170.4,51.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.4,178h-4.3v6.3H63v-14.8h5.4c2.6,0,4.5,1.6,4.5,4.3C72.9,176.4,71,178,68.4,178z M68.3,170.4h-4.2v6.5 h4.2c2,0,3.5-1,3.5-3.3C71.8,171.5,70.3,170.4,68.3,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.5,182.9c-1,1-2.3,1.5-3.7,1.5c-1.4,0-2.7-0.5-3.7-1.5c-1.4-1.4-1.4-2.7-1.4-6c0-3.4,0-4.7,1.4-6 c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5c1.4,1.4,1.4,2.7,1.4,6C88.9,180.2,88.8,181.5,87.5,182.9z M86.6,171.4 c-0.7-0.8-1.8-1.1-2.8-1.1c-1.1,0-2.1,0.4-2.8,1.1c-1.1,1.1-1.1,2.2-1.1,5.4c0,3.2,0.1,4.3,1.1,5.4c0.8,0.7,1.8,1.1,2.8,1.1 c1.1,0,2.1-0.4,2.8-1.1c1.1-1.1,1.1-2.2,1.1-5.4C87.7,173.6,87.6,172.5,86.6,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.7,184.3l-3.5-6.8h-4.1v6.8H96v-14.8h5.6c2.4,0,4.3,1.4,4.3,4c0,2.2-1.3,3.6-3.4,4l3.6,6.9H104.7z  M101.5,170.4h-4.4v6h4.4c1.9,0,3.3-1,3.3-3C104.8,171.4,103.4,170.4,101.5,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.5,184.3l-1.3-3.6h-6.9l-1.3,3.6h-1.2l5.5-14.8h1l5.5,14.8H121.5z M116.8,170.9l-3.1,8.7h6.2L116.8,170.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.1,170.4v13.8H130v-13.8h-4.4v-1h10v1H131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.6,184.3v-14.8h1.1v14.8H141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.6,182.9c-1,1-2.3,1.5-3.7,1.5c-1.4,0-2.7-0.5-3.7-1.5c-1.4-1.4-1.4-2.7-1.4-6c0-3.4,0-4.7,1.4-6 c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5c1.4,1.4,1.4,2.7,1.4,6C160,180.2,160,181.5,158.6,182.9z M157.7,171.4 c-0.8-0.8-1.8-1.1-2.8-1.1c-1.1,0-2.1,0.4-2.8,1.1c-1.1,1.1-1.1,2.2-1.1,5.4c0,3.2,0.1,4.3,1.1,5.4c0.8,0.7,1.8,1.1,2.8,1.1 c1.1,0,2.1-0.4,2.8-1.1c1.1-1.1,1.1-2.2,1.1-5.4C158.9,173.6,158.8,172.5,157.7,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.8,184.3l-8.6-12.9v12.9h-1.1v-14.8h1.1l8.6,12.9v-12.9h1.1v14.8H176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.1,184.3v-14.8h1.1v13.8h7.9v1H194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.2,184.3v-14.8h1.1v14.8H209.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.3,184.3V172l-4.5,10.2h-1.1l-4.6-10.2v12.2H218v-14.8h1.1l5.2,11.4l5-11.4h1.1v14.8H229.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.2,184.3v-14.8h1.1v14.8H238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.9,170.4v13.8h-1.1v-13.8h-4.4v-1h10v1H250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.4,184.3v-14.8h9v1h-7.9v5.9h6.7v1h-6.7v6h7.9v1H261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.7,182.9c-0.9,0.9-2.2,1.4-3.7,1.4h-5v-14.8h5c1.5,0,2.8,0.5,3.7,1.4c1.5,1.5,1.4,3.9,1.4,5.9 C287.1,178.6,287.2,181.4,285.7,182.9z M284.9,171.6c-0.9-0.9-2-1.1-3.2-1.1h-3.6v12.8h3.6c1.2,0,2.3-0.3,3.2-1.1 c1.2-1.2,1.1-3.8,1.1-5.5C286,175,286.1,172.8,284.9,171.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.9,102.3H84.5c-0.9,12.7-11.6,22.8-24.5,22.8c-13,0-23.6-10.1-24.5-22.8H12.6c0.9,25.3,21.8,45.6,47.3,45.6 c9,0,17.5-2.5,24.6-6.9v6.9h22.7v-17.5C101.7,122.4,98.2,112.7,97.9,102.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.9,102.3h-13.4c-0.9,12.8-11.5,22.9-24.5,22.9s-23.6-10.1-24.5-22.9h-22.8c0.9,25.4,21.7,45.6,47.3,45.6 c9,0,17.5-2.5,24.6-6.9v6.9h22.7v-17.5C191.7,122.4,188.2,112.7,187.9,102.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.9,125.2c-13,0-23.7-10.1-24.5-22.9h-22.8c0.9,25.4,21.7,45.6,47.3,45.6c25.6,0,46.4-20.3,47.3-45.6 h-22.8C263.6,115,252.9,125.2,239.9,125.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.9,75.8c13,0,23.6,10.1,24.5,22.8h13.4c0.2-6.9,1.8-13.4,4.4-19.3c-7.8-15.6-23.8-26.2-42.4-26.2 c-25.6,0-46.4,20.2-47.3,45.6h22.8C36.3,85.9,47,75.8,59.9,75.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M149.9,75.9c13,0,23.6,10.1,24.5,22.8h13.4c0.2-6.8,1.8-13.4,4.4-19.3c-7.8-15.6-23.8-26.2-42.4-26.2 c-25.5,0-46.4,20.2-47.3,45.5h22.8C126.3,86,137,75.9,149.9,75.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M264.6,15.3v44.8c-7.2-4.4-15.6-6.9-24.6-6.9c-25.5,0-46.4,20.2-47.3,45.5h22.8c1-12.7,11.6-22.8,24.5-22.8 c13,0,23.6,10.1,24.5,22.8h22.8V15.3H264.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadLogoWms);
export default __webpack_public_path__ + "static/media/aad-logo-wms.c3670cfef90488fe39c4a615e9ba7a54.svg";
export { ForwardRef as ReactComponent };